const STATUS_BADGE = {
  "In Progress": "bg-blue-50 text-blue-700",
  Completed: "bg-emerald-50 text-emerald-700",
  Cancelled: "bg-red-50 text-red-700",
  "On Hold": "bg-amber-50 text-amber-700",
};

const StatusBadge = ({ status }) => {
  if (!status) return <span className="text-gray-500">—</span>;
  const cls = STATUS_BADGE[status] || "bg-gray-100 text-gray-700";
  return (
    <span
      className={`inline-block text-[10px] font-semibold px-1.5 py-0.5 rounded ${cls}`}
    >
      {status}
    </span>
  );
};

const Card = ({ children }) => (
  <div className="bg-white border border-gray-100 shadow-sm rounded-lg p-5 space-y-3">
    {children}
  </div>
);

const Field = ({ label, value }) => {
  const isEmpty = value === null || value === undefined || value === "";
  return (
    <div className="flex items-start text-sm">
      <span className="w-40 shrink-0 text-xs font-medium text-gray-500 pt-px">
        {label}:
      </span>
      <span className="text-gray-900">{isEmpty ? "—" : value}</span>
    </div>
  );
};

const btnPrimary =
  "px-3 py-1.5 font-medium text-white bg-blue-600 hover:bg-blue-700 rounded";
const btnWarning =
  "px-3 py-1.5 font-medium text-white bg-amber-500 hover:bg-amber-600 rounded";

const ManagerStatusCard = ({ project }) => {
  const formatDateTime = (date) =>
    new Date(date).toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });

  return (
    <section>
      <div className="flex justify-between items-center mb-3">
        <h2 className="text-xl font-bold text-gray-900">Manager & Status</h2>
        <div className="flex items-center gap-2 text-sm">
          <button className={btnWarning}>Complete</button>
          <button className={btnPrimary}>Cancel</button>
        </div>
      </div>

      <Card>
        <Field
          label="Primary Manager"
          value={
            project.primaryManager
              ? `${project.primaryManager.first_name} ${project.primaryManager.last_name}`
              : ""
          }
        />
        <Field
          label="Secondary Manager"
          value={
            project.secondaryManager
              ? `${project.secondaryManager.first_name} ${project.secondaryManager.last_name}`
              : ""
          }
        />
        <Field label="Status" value={<StatusBadge status={project.status} />} />
        <Field
          label="Deadline"
          value={
            project.deadline_at ? formatDateTime(project.deadline_at) : ""
          }
        />
      </Card>
    </section>
  );
};

export default ManagerStatusCard;
